import React from 'react'
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';


const DeleteMeal = ({ deleteMeal, id }) => {
    return (
            <IconButton onClick={() => { deleteMeal(id) }}>
                <DeleteIcon ></DeleteIcon>
            </IconButton>
    )
}

export default DeleteMeal
